// removed by extract-text-webpack-plugin
module.exports = {"component":"_18yLxJC3BUUCUJq_lf6O99","header":"dotzRpcmJTsEvVtBSi1uL","content":"_3nXno3fRQafMtEwzqAw71g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadList/MessageThreadList.css
// module id = 1364
// module chunks = 0